// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// `ng build -c devsite` replaces `environment.ts` with `environment.devsite.ts`.
// The list of file replacements can be found in `angular.json`.
import config from '../../auth_config.dev.json';

/**
 * Import Data for the Auth0 Authentication
 */
const {appName, domain, clientId, audience, organization, apiUri, apiUri2, errorPath } = config as {
    appName: string,
    domain: string;
    clientId: string;
    audience: string;
    organization: string;
    apiUri: string;
    apiUri2: string;
    errorPath: string;
};

/**
 * Environment Variable for Development Site
 */
export const environment = {
    appName:"PRISMPDM-DEV",
	defaultImagePath: 'https://stmgwebappstorage.blob.core.windows.net/prismpdm-dev/',
	defaultNoImage: 'assets/noimage.png',
	production: false,
	devsite: true,
	localsite: false,
	auth: {
        domain,
        clientId,        
        authorizationParams: {
            redirect_uri: window.location.origin , //+ '/auth0login',
            ...(audience && audience !== 'YOUR_API_IDENTIFIER' ? { audience } : null),
            organization: organization, 
        },        
        errorPath,
        // tokenSigningAlg: 'RS256'
    },
	httpInterceptor: {
		allowedList: [`${apiUri}/*`],
	},
	authUrl: apiUri,
	apiUrl: apiUri,
	authUrl2: apiUri2,
	apiUrl2: apiUri2,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
